const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()

// Basic Functions
$(document).ready(function(){

	// ##############################################
	// ################## fancybox ##################
	// ##############################################  
  
  $('.image-fancybox').on('click', function (e) {
    e.preventDefault();
    var target = this.href;
    //console.info(target);
    $.fancybox.open({
      src: target,
      type: 'image',
      opts: {
        buttons: [
        //"zoom",
        //"share",
        "slideShow",
        //"fullScreen",
        "download",
        //"thumbs",
        "close"],
        afterShow: function afterShow(instance, current) {
          //console.info( 'done!' );
        }
      }
    });
  });

  //$('.product-image-fancybox').on('click', function (e) {
  //  e.preventDefault();
  //  var target = this.href;
  //  //console.info(target);
  //  $.fancybox.open({
  //    src: target,
  //    type: 'image',
  //    opts: {
  //      baseTpl:
  //        '<div class="fancybox-container fancybox-container-product-image" role="dialog" tabindex="-1">' +
  //        '<div class="fancybox-bg"></div>' +
  //        '<div class="fancybox-inner">' +
  //        '<div class="fancybox-infobar">' +
  //        "<span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span>" +
  //        "</div>" +
  //        '<div class="fancybox-toolbar">{{buttons}}</div>' +
  //        '<div class="fancybox-navigation">{{arrows}}</div>' +
  //        '<div class="fancybox-stage"></div>' +
  //        '<div class="fancybox-caption"></div>' +
  //        "</div>" +
  //        "</div>",
  //      buttons: [
  //      //"zoom",
  //      //"share",
  //      "slideShow",
  //      //"fullScreen",
  //      "download",
  //      //"thumbs",
  //      "close"],
  //      afterShow: function afterShow(instance, current) {
  //        //console.info( 'done!' );
  //      }
  //    }
  //  });
  //});


  $().fancybox({
    selector : '.product-slider .product-image-fancybox',
    backFocus : false,
    //thumbs: {
    //  autoStart : true
    //},
    preventCaptionOverlap: true,
    arrows: true,
    buttons: [
      //"zoom",
      //"share",
      //"slideShow",
      //"fullScreen",
      "download",
      //"thumbs",
      "close"],
    afterShow : function( instance, current ) {
      current.opts.$orig.closest(".slick-initialized").slick('slickGoTo', parseInt(current.index), true);
    }
  });



  $('.fancybox-content-link').on('click', function(e) {
    
    e.preventDefault();
    var target = this.hash;
    
    $.fancybox.open({
    	src  : target,
    	type : 'inline',
    	opts : {
    		beforeShow : function( instance, current ) {
          //console.log( current );
          if ($(current.src).hasClass('frame-type-shortcut')) {
            //console.log('Ist Shortcut');
            $(current.src).find('.fancybox-content').show();
          }    
    		}
    	}
    });
    
  });
  

	// ##############################################
	// ################ Match Height ################
	// ##############################################  

  $('.teaser-content').matchHeight();

  
	// ##############################################
	// #################### forms ###################
	// ##############################################  

  $('input, textarea').each(function(){
    if ($(this).val() != "") {
      $(this).addClass("has-content");
    } else {
      $(this).removeClass("has-content");
    }
  });
  
  $('input, textarea').focusin(function(){
    $(this).addClass("focus");
  });

  $('input, textarea').focusout(function(){
    $(this).removeClass("focus");
    if ($(this).val() != "") {
      $(this).addClass("has-content");
    } else {
      $(this).removeClass("has-content");
    }
  });  
  
  // ##############################################
	// ################## On Screen #################
	// ##############################################  
  
	jQuery.fn.isOnScreen = function()
	{
	    var win = jQuery(window);
 
	    var viewport = {
	        top : win.scrollTop(),
	        left : win.scrollLeft()
	    };
	    viewport.right = viewport.left + win.width();
	    viewport.bottom = viewport.top + win.height();
 
	    var bounds = this.offset();
	    bounds.right = bounds.left + this.outerWidth();
	    bounds.bottom = bounds.top + this.outerHeight();
 
	    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	};
  
  
	// ##############################################
	// ############### Image-Sections ###############
	// ##############################################
  
	var startAnimationInit = function () {
    $('.animation-start').each(function() {
      if($(this).isOnScreen() && !$(this).hasClass('animation-started')){
         $(this).addClass('animation-started');
      }
    });
	};
	var startAnimationScroll = function () {
    $('.animation-start').each(function() {
      if($(this).isOnScreen() && !$(this).hasClass('animation-started')){
         $(this).addClass('animation-started');
      }
    });
	};
  if ($('.animation-start').length) {
    $('#container').imagesLoaded( function() {
      startAnimationInit();
    });
  }
  $(window).scroll(startAnimationScroll);

      
});